import axios from "../../axios";

const api = {
  updateScopeThree({ questionnaireId, data }, accessToken) {
    const headers = { headers: { "Authorization": `Bearer ${accessToken}` } };
    return axios.put(`/supplier-questionnaires/${questionnaireId}/categories`, data, headers)
      .then(({ data }) => data);
  }
}

export default api;